import { IAuctionConfigurations } from '../../../../../redux/reducers';
import { IConfigurationInfoSchema } from '../../internalTypes';
import { getServiceId } from '../getServiceId';
import { mapServiceTypes } from '../mapServiceTypes';

export function mapAuctionConfigurations(configurations?: IConfigurationInfoSchema[] | null): IAuctionConfigurations {
  if (!configurations) {
    return {};
  }

  return configurations.reduce((acc, configuration) => {
    const { serviceTypes, stepBet } = configuration;

    const services = mapServiceTypes(serviceTypes);
    const serviceId = getServiceId({ services });

    acc[serviceId] = {
      serviceId,
      stepBet,
    };

    return acc;
  }, {} as IAuctionConfigurations);
}
